import React, { Component } from 'react';
import { Card, Table, Grid, Dropdown, Form, Segment, Button, Header, Divider, Radio, Icon } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import AddGuarantor from './AddGuarantor';
import AddAccount from './AddAccount';
import Batch from './Batch';
import { getConsumerDetails, getCurrencyCodes, createBatch, getUserProfile, getUserCorpBatch, deleteAccountFromBatch, finalizeBatch, exportXLSX } from '../../utils/rest';
import MessageBox from '../../ui/MessageBox';
import Loading from '../Loading';
import validation from '../../components/SimpleReactValidation';
const consumerDemo = {
    acsBatchRefId: "",
    acsConsumerFirstName: "",
    acsConsumerMiddleName: "",
    acsConsumerLastName: "",
    acsConsumerSsn: "",
    acsConsumerDob: "",
    acsConsumerAddressSuite: "",
    acsConsumerDrivingLicense: "",
    acsPhone: "",
    acsAltPhone: "",
    acsConsumerAddress1: "",
    acsConsumerAddress2: "",
    acsLocality: "",
    acsRegion: "",
    acsPostalCode: "",
    acsEmployerName: "",
    acsEmployerPhone: "",
    acsEmployerAddress: "",
    acsEmployerLocality: "",
    acsEmployerRegion: "",
    acsEmployerPostalCode: "",
}
const accountInfo = {
    acsAccountId: "",
    acsClientId: "",
    acsInvoiceId: "",
    acsAccountFor: "",
    acsPatientFirstName: "",
    acsPatientLastName: "",
    acsPrincipalReferred: "",
    acsInterestReferred: "",
    acsInterestRate: "",
    acsOtherReferred: "",
    acsTotalReferred: "",
    acsLastPaymentDate: "",
    acsServiceStartDate: "",
    acsServiceEndDate: "",
    acsDelinquencyDate: "",
    acsFirstBillingDate: "",
    acsComments: "",
    acsDeleted: "N",
    acsCurrencyCode: "USD",
}
class NewAccount extends Component {

    constructor(props) {
        super(props);
        this.validator = validation();
        this.state = {
            loading: true,
            interestAllowed: false,
            maxSecondaryGuarantor: 5,
            inputs: {
                acsBusiness: 'N',
                accountInfo: [accountInfo],
                consumerDemo: consumerDemo,
                secondaryConsumers: [],
                acsClientId: ""
            },
            addedToBatch: [],
            deleteFromBatch: [],
            showAll: false,
            yetToSubmit: [],
            mine: [],
            all: [],
            deleteCheckedModal: false,
            showAllModal: false,
            showMineModal: false,
            errorMessage: [],
            errorOpen: false,
            method: "POST",
            currencyCodes: []
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "am_enter-new-accounts.md");
        this.enableDisableInterest();
        this.loadUnsubmittedAccounts(false);
        this.loadCurrencyCodes();
        if (this.props.params && this.props.params.id) {
            getConsumerDetails(this.props.params.id).then((response) => {
                if (response !== null && (response instanceof Object)) {
                    this.setState({
                        inputs: {
                            ...this.state.inputs,
                            consumerDemo: this.setConsumer(response),
                            secondaryConsumers: response.secondaryConsumers.map((res) => {
                                if (res instanceof Object) {
                                    return this.setConsumer(res);
                                }
                                return consumerDemo;
                            }),
                            acsBusiness: this.props._ifNull(response.conBusiness, 'N')
                        }
                    })
                }
            });
        }

    }

    handleChangeSelect = (idx) => (evt, e) => {
        const changedItems = this.state.inputs.accountInfo.map((item, sidx) => {
            if (idx !== sidx) return item;
            return { ...item, [e.name]: e.value };
        });
        this.setState({
            inputs: {
                ...this.state.inputs,
                accountInfo: changedItems
            }
        });
    }

    componentDidUpdate(prevProps) {

        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.loadUnsubmittedAccounts(false);
            this.setState({
                maxSecondaryGuarantor: 5,
                inputs: {
                    acsBusiness: 'N',
                    accountInfo: [accountInfo],
                    consumerDemo: consumerDemo,
                    secondaryConsumers: [],
                    acsClientId: ""
                },
                addedToBatch: [],
                deleteFromBatch: [],
                showAll: false,
                yetToSubmit: [],
                mine: [],
                all: [],
                deleteCheckedModal: false,
                showAllModal: false,
                showMineModal: false,
                errorMessage: []
            })
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }


    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "Enter New Accounts", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={6} className="required">
                                        <label>Load Account to the Following Client:</label>
                                        <Dropdown className="fluid" placeholder='Select Client ID' search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtocreateaccount; return client; })} name="acsClientId" value={this.props._ifNull(this.state.inputs.acsClientId, "")} onChange={this.handleChange} ></Dropdown>
                                        {this.validator.message('Client ID', this.state.inputs.acsClientId, 'required')}
                                    </Form.Field>
                                    <Form.Field width={6} />
                                    <Form.Field width={4}>
                                        <Dropdown text='Downloadable Forms' icon='download' labeled button className='icon small right floated push-down'>
                                            <Dropdown.Menu>
                                                <Dropdown.Header icon='tags' content='SELECT A FORM TO DOWNLOAD' />
                                                <Dropdown.Item>Sample Account Assignment</Dropdown.Item>
                                                <Dropdown.Item>Sample Commercial Account Assignment</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Form.Field>
                                </Form.Group>
                                <Divider></Divider>
                                <Form.Group inline>
                                    <Form.Field width={6}>
                                        <label>Is the account(s) owed by a business?</label>
                                        <Radio
                                            label='No'
                                            name='acsBusiness'
                                            value='N'
                                            checked={this.state.inputs.acsBusiness === 'N'}
                                            onChange={this.handleChange}

                                        />&nbsp;&nbsp;
                                        <Radio
                                            label='Yes'
                                            name='acsBusiness'
                                            value='Y'
                                            checked={this.state.inputs.acsBusiness === 'Y'}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Segment.Group raised>
                                    <Segment inverted className="grey">
                                        <Header as="h4">
                                            <Icon name="user" />
                                            <div className="content">
                                                Primary Responsible Party
                                            </div>
                                        </Header>
                                    </Segment>
                                    <AddGuarantor unique={0} validator={this.validator} {...this.props} isBusiness={this.state.inputs.acsBusiness === 'Y'} inputs={this.state.inputs.consumerDemo} handleChange={this.handleConsumer} />
                                    {
                                        (() => {
                                            return this.state.inputs.secondaryConsumers.map((item, index) => {
                                                return (
                                                    <Segment clearing key={index}>
                                                        <Segment inverted className="grey">
                                                            <Header as="h4">
                                                                <Icon name="user" />
                                                                <div className="content">
                                                                    Secondary Responsible Party [ {index + 1} ]
                                                            </div>
                                                            </Header>
                                                        </Segment>
                                                        <AddGuarantor validator={this.validator} unique={index + 1} key={index} {...this.props} isBusiness={this.state.inputs.acsBusiness === 'Y'} inputs={item} handleChange={this.handleListConsumer(index)} />
                                                    </Segment>
                                                )
                                            })

                                        })()
                                    }
                                    <Segment clearing>
                                        <Button className="left floated small button" onClick={this.addGuarantor}>Add Another Guarantor</Button>
                                    </Segment>
                                </Segment.Group>

                                <Segment.Group raised style={{ marginBottom: 10 }}>
                                    <Segment inverted className="grey">
                                        <Header as="h4">
                                            <div className="content">
                                                Account/Debt Information
                                                                </div>
                                        </Header>
                                    </Segment>
                                    {
                                        (() => {
                                            return this.state.inputs.accountInfo.map((item, index) => {
                                                return (
                                                    <AddAccount unique={index} validator={this.validator} acsClientId={this.state.inputs.acsClientId} key={index} {...this.props} currencyCodes={this.state.currencyCodes} inputs={item} handleChangeSelect={this.handleChangeSelect(index)} handleChange={this.handleListAccount(index)} removeCharge={() => this.removeCharge(index)} interestAllowed={this.state.interestAllowed} />
                                                )
                                            })

                                        })()
                                    }
                                    <Segment clearing>
                                        <Button color="blue" className="left floated small" onClick={this.addCharge}>Add Another Charge</Button>
                                        <Button className="left floated small" onClick={this.handleSubmit}>Add Charge to Batch</Button>
                                    </Segment>
                                </Segment.Group>
                            </Form>
                            <Segment.Group raised>
                                <Segment.Group horizontal>
                                    <Segment color="grey" inverted>
                                        <Header as="h4">
                                            <Icon name="cog" />
                                            <div className="content">
                                                New Accounts
                                            </div>
                                        </Header>
                                    </Segment>
                                    <Segment color="grey" inverted className="right-btnHead">
                                        <Button.Group className="right floated small buttons">
                                            <Button className={this.state.showAll ? "ui button white" : "ui button black"} onClick={() => { this.showMine(false) }}>Show Mine</Button>
                                            <Button className={this.state.showAll ? "ui button black" : "ui button  white"} onClick={() => { this.showAll(false) }}>Show All</Button>
                                        </Button.Group>
                                    </Segment>
                                </Segment.Group>
                                {<Grid className="grid-bottom">
                                    {<Grid.Column width={4}>
                                        <p className="row-select">[{!this.state.showAll ? "Mine" : "All"}]</p>
                                    </Grid.Column>
                                    /*<Grid.Column width={11}>
                                        <div className="ui right floated icon small search input search-ph">
                                            <i className="search icon"></i>
                                            <input placeholder="Search Table Results" type="text" />
                                        </div>
                                    </Grid.Column>*/}
                                    <Grid.Column width={1} floated='right'>
                                        <Button onClick={() => { exportXLSX({ "Client ID": "acsClientId", "Client Acct#": "acsInvoiceId", "Last Name": "consumer.acsConsumerLastName", "First Name": "consumer.acsConsumerFirstName", "For": "acsAccountFor", "DLP": "acsLastPaymentDate", "Service Start": "acsServiceStartDate", "Service End": "acsServiceEndDate", "PBR": "acsPrincipalReferred", "INTR": "acsInterestReferred", "OCR": "acsOtherReferred", "Total": "acsTotalReferred" }, this.state.addedToBatch, "Unsubmitted.xlsx") }} className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>}

                                <Batch {...this.props} batch={(this.state.addedToBatch instanceof Array) && this.state.addedToBatch.length > 0 ? this.state.addedToBatch : []}
                                    checkedItemsForDelete={this.checkedItemsForDelete}
                                    updateBatch={this.updateBatch}
                                    deleted={[]}
                                />
                                <Card.Group>
                                    <Card>
                                        <Card.Content>

                                            <Table className="celled striped" >
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell className="left aligned">  Client </Table.HeaderCell>
                                                        <Table.HeaderCell className="left aligned">  Count </Table.HeaderCell>
                                                        <Table.HeaderCell className="left aligned">  Total </Table.HeaderCell></Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {
                                                        (() => {
                                                            return this.state.yetToSubmit.map((item, index) => {
                                                                return (
                                                                    <Table.Row key={index}>
                                                                        <Table.Cell className="left aligned">  {item.client} </Table.Cell>
                                                                        <Table.Cell className="left aligned">  {item.count} </Table.Cell>
                                                                        <Table.Cell className="right aligned">  {item.total} </Table.Cell>
                                                                    </Table.Row>
                                                                )
                                                            })
                                                        }
                                                        )()
                                                    }
                                                </Table.Body>
                                            </Table>

                                        </Card.Content>
                                    </Card>
                                </Card.Group>
                                <Segment clearing>
                                    <Button.Group className="small">
                                        <Button color="grey" /* onMouseEnter={() => { this.showMine(false) }} */ onClick={() => { this.showMine(true) }}>Finalize Mine </Button>
                                        <Button color="black" /* onMouseEnter={() => { this.showAll(false) }} */ onClick={() => { this.showAll(true) }}>Finalize All</Button>
                                        <Button color="grey" onClick={() => {
                                            this.setState((prevState, props) => {
                                                return {
                                                    deleteCheckedModal: prevState.deleteFromBatch.length > 0 ? true : false,
                                                    errorMessage: ["Please select the checkbox"],
                                                    errorOpen: prevState.deleteFromBatch.length > 0 ? false : true,
                                                }
                                            })
                                        }}>Delete Checked</Button>
                                    </Button.Group>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} box={5} size="tiny" open={this.state.showAllModal} close={this.close} yesHandle={this.finalize} />
                <MessageBox {...this.props} box={6} size="tiny" open={this.state.showMineModal} close={this.close} yesHandle={this.finalize} />
                <MessageBox {...this.props} box={12} size="tiny" open={this.state.deleteCheckedModal} close={this.close} contentTitle="Delete checked?" content="Are you sure you want to delete checked?" yesHandle={this.deleteChecked} />
                <MessageBox {...this.props} size="mini" box={11} open={this.state.errorOpen} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }

    loadCurrencyCodes = () => {
        getCurrencyCodes().then((response) => {
            if(response){
                const curCodes = response.map((item) => {
                    return {
                        key: item.curId,
                        value: item.curIsoCode,
                        text: item.curIsoCode
                    };
                })
                this.setState((prevState, props) => {
                    return { currencyCodes: curCodes }
                })
            }
        })
    }

    loadUnsubmittedAccounts = (finalize) => {
        getUserCorpBatch(this.props.items.currentCorporate, { showAll: this.state.showAll }).then((response) => {
            if (response instanceof Array) {
                this.setState((prevState, props) => {
                    return {
                        addedToBatch: response,
                        yetToSubmit: this.getCount(response),
                        mine: (!prevState.showAll) ? response : prevState.mine,
                        all: (prevState.showAll) ? response : prevState.all,
                        showAllModal: (finalize && prevState.showAll && response.length > 0) ? finalize : false
                    }
                }, () => {
                    if (finalize && !this.state.showAll && response.length > 0) {
                        this.finalize();
                    }
                })
            }
        }).then((error) => {
            this.setState({
                loading: false
            });
        });
    }

    getCount = (response) => {
        let clientGroup = this.groupBy(response, "acsClientId");
        let yetToSubmit = [];
        for (let key in clientGroup) {
            let total = 0;
            let count = 0;
            if (clientGroup[key] instanceof Array) {

                clientGroup[key].forEach(function (acx) {
                    total = Number(total) + Number(acx.acsTotalReferred);
                    count = ++count;
                }, this);
                yetToSubmit.push({
                    total: this.props._currencyFormat(total),
                    client: key,
                    count: count
                })
            }
        }
        return yetToSubmit;
    }

    groupBy = (items, key) => items.reduce(
        (result, item) => ({
            ...result,
            [item[key]]: [
                ...(result[item[key]] || []),
                item,
            ],
        }),
        {},
    );

    finalize = () => {
        this.setState({
            loading: true
        }, () => {
            finalizeBatch(this.props.items.currentCorporate, { finalizeAll: this.state.showAllModal }).then((response) => {
                if (response !== null) {
                    this.setState({
                        showAllModal: false,
                        showMineModal: true,
                        loading: false
                    }, () => { this.loadUnsubmittedAccounts(false) })
                }
            }).then(() => {
                this.setState({
                    loading: false,
                    showAllModal: false
                });
            });
        });
    }

    enableDisableInterest = () => {
        getUserProfile().then((response) => {
            if (response instanceof Object) {
                this.setState({
                    interestAllowed: response.usrEnterInterest === 'Y' ? true : false
                })
            }
        }
        );
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                let consumerAccounts = this.state.inputs.accountInfo;
                let data = Object.assign(
                    this.state.inputs.consumerDemo,
                    {
                        secondaryConsumers: this.state.inputs.secondaryConsumers,
                        consumerAccounts: consumerAccounts.map((a) => {
                            a.acsClientId = this.state.inputs.acsClientId
                            delete a.consumer
                            a.acsServiceStartDate = this.props._ifEmpty(a.acsServiceStartDate, a.acsServiceEndDate)
                            return a;
                        }),
                        acsBusiness: this.state.inputs.acsBusiness
                    });
                createBatch(this.state.method, this.props.items.currentCorporate, data).then((response) => {
                    if (response != null && (response instanceof Array)) {
                        this.validator = validation();
                        this.setState({
                            inputs: {
                                acsBusiness: 'N',
                                accountInfo: [accountInfo],
                                consumerDemo: consumerDemo,
                                secondaryConsumers: [],
                                acsClientId: ""
                            },
                            addedToBatch: response,
                            yetToSubmit: this.getCount(response),
                            mine: response,
                            all: [],
                            showAllModal: false
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                });
            })
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            this.showError();
        }
    }

    showError = () => {
        this.setState({
            errorMessage: this.props._errorItems(this.removeNumber(this.validator.fields)),
            errorOpen: true
        })
    }

    removeNumber = (fields) => {
        let newFields = {};
        for (let key in fields) {
            let r = key.replace(/[0-9]/g, "");
            newFields[r] = fields[key];
        }
        return newFields;
    }

    handleConsumer = (e, evt) => {
        this.setState({
            inputs: {
                ...this.state.inputs,
                consumerDemo: {
                    ...this.state.inputs.consumerDemo,
                    [evt.name]: evt.value
                }
            }
        })
    }

    handleChange = (e, evt) => {
        this.setState({
            inputs: {
                ...this.state.inputs,
                [evt.name]: evt.value
            }
        })
    }


    handleAccount = (e, evt) => {
        this.setState({
            inputs: {
                ...this.state.inputs,
                accountInfo: {
                    ...this.state.inputs.accountInfo,
                    [evt.name]: evt.value
                }
            }
        })
    }

    handleListConsumer = (idx) => (e, evt) => {
        const changedItems = this.state.inputs.secondaryConsumers.map((item, sidx) => {
            if (idx !== sidx) return item;
            return { ...item, [evt.name]: evt.value };
        });
        this.setState({
            inputs: {
                ...this.state.inputs,
                secondaryConsumers: changedItems
            }
        });
    }

    handleListAccount = (idx) => (evt) => {
        const changedItems = this.state.inputs.accountInfo.map((item, sidx) => {
            if (idx !== sidx) return item;
            return { ...item, [evt.target.name]: evt.target.value };
        });
        this.setState({
            inputs: {
                ...this.state.inputs,
                accountInfo: changedItems
            }
        });
    }

    addGuarantor = () => {
        //this.validator.allValid()
        if (true) {
            if (this.state.maxSecondaryGuarantor > 0) {
                this.setState((prevState, props) => {
                    let secCon = prevState.inputs.secondaryConsumers;
                    secCon.push(consumerDemo);
                    return {
                        maxSecondaryGuarantor: --prevState.maxSecondaryGuarantor,
                        inputs: {
                            ...this.state.inputs,
                            secondaryConsumers: secCon
                        }
                    }
                })
            } else {

            }
        } else {
            // this.showError();
        }
    }

    addCharge = () => {
        if (this.validator.allValid()) {
            this.setState((prevState, props) => {
                let addCharge = prevState.inputs.accountInfo;
                addCharge.push(accountInfo);
                return {
                    inputs: {
                        ...this.state.inputs,
                        accountInfo: addCharge
                    }
                }
            })
        } else {

            this.validator.showMessages();
            this.forceUpdate();
            this.showError();
        }
    }

    removeCharge = (index) => {
        this.setState((prevState, props) => {
            let addCharge = prevState.inputs.accountInfo;
            addCharge.splice(index, 1);
            return {
                inputs: {
                    ...this.state.inputs,
                    accountInfo: addCharge
                }
            }
        });
        this.validator = validation();
    }



    checkedItemsForDelete = (acsAccountId, addedOrRemove) => {
        let deleteItems = this.state.deleteFromBatch;
        if (addedOrRemove) {
            deleteItems.push(acsAccountId);
            this.setState({
                ...this.state,
                deleteFromBatch: deleteItems
            })
        } else {
            var rIndex = deleteItems.indexOf(acsAccountId);
            if (rIndex !== -1) {
                deleteItems.splice(rIndex, 1);
                this.setState({
                    ...this.state,
                    deleteFromBatch: deleteItems
                })
            }
        }

    }

    updateBatch = (item) => {
        this.setState({
            inputs: {
                ...this.state.inputs,
                accountInfo: [item],
                consumerDemo: item.consumer,
                secondaryConsumers: (item.consumer.secondaryConsumers instanceof Array) ? item.consumer.secondaryConsumers : [],
                acsClientId: item.acsClientId,
                acsBusiness: item.consumer.acsBusiness
            },
            method: "PUT"
        })
    }

    deleteChecked = () => {
        //Need to open pop
        let deleteChecked = this.state.deleteFromBatch;
        let accounts = this.state.addedToBatch.filter((acc) => {
            return deleteChecked.indexOf(acc.acsAccountId) === -1;
        });
        if (deleteChecked.length > 0) {
            // this.setState({
            //     loading: true
            // }, () => {
            deleteAccountFromBatch(this.props.items.currentCorporate, deleteChecked).then((response) => {
                if (response != null && response === true) {
                    this.setState((prevState, props) => {
                        return {
                            addedToBatch: accounts,
                            deleteFromBatch: [],
                            yetToSubmit: this.getCount(accounts),
                            all: prevState.all.filter((acc) => {
                                return deleteChecked.indexOf(acc.acsAccountId) === -1;
                            }),
                            mine: prevState.mine.filter((acc) => {
                                return deleteChecked.indexOf(acc.acsAccountId) === -1;
                            }),
                            deleteCheckedModal: false
                        }
                    })
                }
            })
            // .then(() => {
            //     this.setState({
            //         loading: false
            //     })
            // })
            // });
        }
    }

    showAll = (finalize) => {
        this.setState({
            showAll: true
        }, () => {
            if (this.state.all.length === 0) {
                this.loadUnsubmittedAccounts(finalize)
            } else {
                this.setState((prevState, props) => {
                    return {
                        addedToBatch: prevState.all,
                        yetToSubmit: this.getCount(prevState.all),
                        showAllModal: (finalize && prevState.all.length > 0) ? finalize : false
                    }
                })
            }
        })
    }

    showMine = (finalize) => {
        this.setState({
            showAll: false
        }, () => {
            if (this.state.mine.length === 0) {
                this.loadUnsubmittedAccounts(finalize);
            } else {
                this.setState((prevState, props) => {
                    return {
                        addedToBatch: prevState.mine,
                        yetToSubmit: this.getCount(prevState.mine),
                    }
                }, () => {
                    if (this.state.mine.length > 0 && finalize) {
                        this.finalize();
                    }
                })
            }

        })
    }

    setConsumer = (response) => {
        return {
            acsBatchRefId: "",
            acsConsumerFirstName: this.props._ifNull(response.conFirstName, ""),
            acsConsumerMiddleName: "",
            acsConsumerLastName: this.props._ifNull(response.conLastName, ""),
            acsConsumerSsn: this.props._ifNull(response.conSsn, ""),
            acsConsumerDob: this.props._ifNull(response.conDob, ""),
            acsConsumerDrivingLicense: this.props._ifNull(response.conDrivingLicense, ""),
            acsPhone: this.props._ifNull(response.cphPhone, ""),
            acsAltPhone: this.props._ifNull(response.cphAltPhone, ""),
            acsConsumerAddress1: this.props._ifNull(response.coaAddress1, ""),
            acsConsumerAddress2: this.props._ifNull(response.coaAddress2, ""),
            acsConsumerAddressSuite: "",
            acsLocality: this.props._ifNull(response.coaLocality, ""),
            acsRegion: this.props._ifNull(response.coaRegion, ""),
            acsPostalCode: this.props._ifNull(response.coaPostalCode, ""),
            acsEmployerName: this.props._ifNull(response.coeEmployer, ""),
            acsEmployerPhone: this.props._ifNull(response.coePhone, ""),
            acsEmployerAddress: this.props._ifNull(response.coeAddress1, ""),
            acsEmployerLocality: this.props._ifNull(response.coeLocality, ""),
            acsEmployerRegion: this.props._ifNull(response.coeRegion, ""),
            acsEmployerPostalCode: this.props._ifNull(response.coePostalCode, ""),
        }
    }

    close = () => {
        this.setState((prevState, props) => {
            return { deleteCheckedModal: false, showAllModal: false, showMineModal: false, errorOpen: false };
        });
    }
}
export default NewAccount;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/NewAccount.js